module.exports = __webpack_public_path__ + "assets/img/20_77_big.489abf44.jpg";